module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Light.ac523705.otf";